export const ENTRYPOOL_OPEN_PARTNER_MODAL = 'ENTRYPOOL_OPEN_PARTNER_MODAL';

export function entryPoolOpenPartnerModal(open) {
  return {
    type: ENTRYPOOL_OPEN_PARTNER_MODAL,
    open,
  };
}
